import { FunctionComponent, useState } from "react";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import IconCards from "./IconCards";
import { IconType } from "./types";
import { getIconType } from "./icons";

export type IconPickerDialogProps = {
  visible?: boolean;
  className?: string;
  onClose: (icon?: string) => void;
  icon?: string;
};

export const IconPickerDialog: FunctionComponent<IconPickerDialogProps> = (
  props
) => {
  const [iconLibrary, setIconLibrary] = useState<IconType>(
    getIconType(props.icon)
  );
  const [icon, setIcon] = useState<string | undefined>(props.icon);

  const abort = () => {
    // Der state muss hier resettet werden, weil die Komponente nicht wirklich ausgehangen wird, sondern nur ausgeblendet wird.
    setIcon(props.icon);
    props.onClose(props.icon);
  };

  const dialogFooter = () => (
    <div>
      <Button
        label="Abbrechen"
        icon="pi pi-times"
        onClick={abort}
        className="p-button-text"
      />
      <Button
        label="Übernehmen"
        icon="pi pi-check"
        onClick={() => props.onClose(icon)}
        autoFocus
      />
    </div>
  );

  return (
    <Dialog
      showHeader
      header={
        <div className="p-d-flex p-justify-between">
          <h3 className="p-m-0">Icon wählen</h3>
          <div>
            <span>Bibliothek:</span>
            <Dropdown
              className="p-mx-2"
              value={iconLibrary}
              onChange={(e) => setIconLibrary(e.value)}
              options={[IconType.FontAwesome, IconType.PrimeIcon]}
            />
          </div>
        </div>
      }
      visible={props.visible}
      className={classNames(props.className, "iconSelectorDialog")}
      focusOnShow
      footer={dialogFooter()}
      closeOnEscape
      modal
      resizable={false}
      draggable={false}
      maximizable={false}
      position="center"
      onHide={abort}
    >
      <div className="iconGrid">
        <IconCards
          iconType={iconLibrary}
          icon={icon}
          onChange={(newIconType, newIcon) =>
            newIconType ? setIcon(newIcon) : setIcon(undefined)
          }
        />
      </div>
    </Dialog>
  );
};
